import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { documentStatusReportPayloadSchema } from './schema'

export const documentStatusReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'document-status',
    component: lazyRouteComponent(() => import('./DocumentStatusReport')),
    validateSearch: (search: Record<string, unknown>) => documentStatusReportPayloadSchema.parse(search)
  })
